import { JitsiConference, JitsiMeet, JitsiParticipant } from "lib/lib-jitsi-meet";
import { action } from "mobx";
import { DataMessage, SpotlightUserMessage } from "../../chat";
import { RoomState } from "../../common/state";
import AbstractDataComponent from "../data/AbstractDataComponent";

export interface HostMessagesManagerProps {
    jitsi: JitsiMeet;
    room: JitsiConference;
    roomState: RoomState;
}

export default class extends AbstractDataComponent<HostMessagesManagerProps> {
    public componentDidMount() {
        const { jitsi, room } = this.props;
        room.on(jitsi.events.conference.ENDPOINT_MESSAGE_RECEIVED, this.handleDataMessageReceived);
    }

    public componentWillUnmount() {
        const { jitsi, room } = this.props;
        room.off(jitsi.events.conference.ENDPOINT_MESSAGE_RECEIVED, this.handleDataMessageReceived);
    }

    @action
    private handleDataMessageReceived = (_participant: JitsiParticipant, message: DataMessage) => {
        const { roomState } = this.props;

        switch (message.kind) {
            case "spotlightUser":
                console.log("received", message);
                const { userId } = message as SpotlightUserMessage;
                roomState.spotlightUserId = userId;
                break;
        }
    };
}
